import React from 'react';
import { WorkflowStatus } from '../types';
interface StatusBadgeProps {
  status: WorkflowStatus;
}
export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status
}) => {
  const config: Record<WorkflowStatus, {
    label: string;
    classes: string;
  }> = {
    pending_validation: {
      label: 'Pending Validation',
      classes: 'bg-amber-100 text-amber-800 border-amber-200'
    },
    processing: {
      label: 'Processing',
      classes: 'bg-blue-100 text-blue-800 border-blue-200'
    },
    ready_for_approval: {
      label: 'Ready for Approval',
      classes: 'bg-indigo-100 text-indigo-800 border-indigo-200'
    },
    approved: {
      label: 'Approved',
      classes: 'bg-teal-100 text-teal-800 border-teal-200'
    },
    rejected: {
      label: 'Rejected',
      classes: 'bg-red-100 text-red-800 border-red-200'
    },
    published: {
      label: 'Published',
      classes: 'bg-emerald-100 text-emerald-800 border-emerald-200'
    },
    error: {
      label: 'Error',
      classes: 'bg-red-100 text-red-800 border-red-200'
    }
  };
  const {
    label,
    classes
  } = config[status] || {
    label: status,
    classes: 'bg-slate-100 text-slate-800 border-slate-200'
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${classes}`} data-id="element-182">
      {label}
    </span>;
};